import {createSlice} from '@reduxjs/toolkit';
import { prepareBlockAsync } from './EnergyReplaceBlockAsyncThunk';
import { energyReplacePages } from './EnergyReplacePages';

const initialState = {
  page: '',
  pagePercent: 0,
  progressBarPoints: [],
  subscriber:{},
  salePackages: [],
  bottomText:'',
  selectedPackage: {},
  errorPage: '',
  summaryDetails: {
    summaryWillBeSentTo: 'sms', //sms|email
    summarySmsNumber: '',
    summaryEmail: '',
    isConfirmTerms: false,
    isReceivingAd: false
  }
};

const energyReplaceBlockSlice = createSlice({
  name: 'energyReplaceBlock',
  initialState: initialState,
  reducers: {
    resetBlock: (state) => initialState,
    initBlock: {
      reducer: (state, action) => {
        state.page = action.payload.page;
        state.progressBarPoints = action.payload.progressBarPoints;
        state.pagePercent = action.payload.pagePercent;
        state.salePackages = action.payload.salePackages;
        state.bottomText = action.payload.bottomText;
      },
      prepare: (action) => {
        const currentBlock = action.energyReplaceBlock;
        const salePackages = currentBlock.salePackages || [];
        const page = 'subscribersPage';
        const pagePercent = getPercentForPage(page);
        const progressBarPoints = energyReplacePages.map(function (item) {
                return item['percent'];
        });
        //console.info('salePackages', salePackages);

        const bottomText = currentBlock.bottomText?.value;

        let payload = {
          page: page,
          progressBarPoints: progressBarPoints,
          pagePercent: pagePercent,
          salePackages: salePackages,
          bottomText: bottomText
        };
        return {payload: payload};
      },
    },
    goToPage: (state, action) => {
      state.pagePercent = getPercentForPage(action.payload);
      state.page = action.payload;
      window.scrollTo(0, 0);
    },
    setSubscriber: (state, action) => {
      state.subscriber = action.payload;
    },
    setSalePackages: (state, action) => {
      state.salePackages = action.payload;
    },
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
    },
    setSummaryDetails: (state, action) => {
      state.summaryDetails = action.payload;
    },
    setErrorPage: (state, action) => {
      state.errorPage = action.payload;
      state.page = 'errorPage';
    },
    reportDWH: (state, action) => {},
  },
  extraReducers: {},
});

export const {
  initBlock,
  resetBlock,
  goToPage,
  setSubscriber,
  setSalePackages,
  setSelectedPackage,
  setSummaryDetails,
  setErrorPage,
  reportDWH,
} = energyReplaceBlockSlice.actions;

export default energyReplaceBlockSlice.reducer;


function getPercentForPage(page) {
  let pageItem = energyReplacePages.find((x) => x.page == page);
    if (pageItem && pageItem.percent) {
      return pageItem.percent;
    }
    else{
      return 0;
    }
}
